import { useParams, useOutletContext } from 'react-router-dom';
import { ScheduleGrid } from '../schedule/list/ScheduleGrid';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setPageTitle } from '../../store/slices/pageTitleSlice';
import { PatientPersonalInfo } from 'patients-experience-client';


export const PatientAppointments = () => {

    const { patientId } = useParams<{ patientId: string }>();
    const dispatch = useDispatch();
    const patient = useOutletContext<PatientPersonalInfo | undefined>();

    useEffect( () => {
        dispatch(setPageTitle('Appointments: Patient Profile | Spire360'));
    }, []);

    return <ScheduleGrid patientId={patientId} scope="Patient" patient={patient} />;
}